import { clsx } from 'clsx';
import { useEffect, useState } from 'react';

import type { AccordionItemProps } from './accordion.types';
import {
  AccordionItemExpandedContext,
  AccordionItemIdContext,
  AccordionItemSetExpandedContext,
} from './accordionItemContext';

export const AccordionItem = ({
  className,
  'data-testid': testId,
  expanded,
  children,
  id,
  defaultExpanded = false,
  onTrack,
  style,
}: AccordionItemProps) => {
  const [itemExpanded, setItemExpanded] = useState(defaultExpanded);

  useEffect(() => {
    setItemExpanded(defaultExpanded);
  }, [defaultExpanded]);

  useEffect(() => {
    if ((expanded || itemExpanded) && onTrack) {
      onTrack();
    }
  }, [expanded, itemExpanded, onTrack]);

  return (
    <AccordionItemExpandedContext.Provider
      value={expanded === undefined ? itemExpanded : expanded}
    >
      <AccordionItemSetExpandedContext.Provider value={setItemExpanded}>
        <AccordionItemIdContext.Provider value={id}>
          <div
            className={clsx(className)}
            id={testId ?? `accordion-item-${id}`}
            data-testid={testId ?? `accordion-item-${id}`}
            style={style}
          >
            {children}
          </div>
        </AccordionItemIdContext.Provider>
      </AccordionItemSetExpandedContext.Provider>
    </AccordionItemExpandedContext.Provider>
  );
};
